import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface UploadFileIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function UploadFileIcon({ color = RoutalPalette.oldWhite, style = {} }: UploadFileIconProps) {
  return (
    <SvgIcon width="17" height="19" viewBox="0 0 17 19" fill="none" style={{ width: `20px`, height: `20px`, ...style }}>
      <g id="Icon">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.7528 1.75581C2.76961 1.75581 1.97258 2.59919 1.97258 3.63953V15.3605C1.97258 16.4008 2.76961 17.2442 3.7528 17.2442H13.2473C14.2305 17.2442 15.0275 16.4008 15.0275 15.3605V7.0605C15.0275 6.61982 14.8815 6.1931 14.6149 5.85457L11.9208 2.43361C11.5825 2.00413 11.0814 1.75581 10.5532 1.75581H3.7528ZM0.785767 3.63953C0.785767 1.90562 2.11415 0.5 3.7528 0.5H10.5532C11.4337 0.5 12.2687 0.913866 12.8325 1.62965L15.5266 5.05062C15.971 5.61484 16.2143 6.32605 16.2143 7.0605V15.3605C16.2143 17.0944 14.886 18.5 13.2473 18.5H3.7528C2.11415 18.5 0.785767 17.0944 0.785767 15.3605V3.63953Z"
          fill={color}
        />
        <path
          id="Vector_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8737 0.918396C11.2014 0.918396 11.4671 1.19952 11.4671 1.5463V4.47654C11.4671 5.51689 12.2641 6.36026 13.2473 6.36026H15.2253C15.553 6.36026 15.8187 6.64138 15.8187 6.98816C15.8187 7.33494 15.553 7.61607 15.2253 7.61607H13.2473C11.6086 7.61607 10.2803 6.21045 10.2803 4.47654V1.5463C10.2803 1.19952 10.5459 0.918396 10.8737 0.918396ZM10.502 10.781C10.2703 11.0262 9.89462 11.0262 9.66288 10.781L9.09345 10.1785V13.6858C9.09345 14.0326 8.82776 14.3137 8.50004 14.3137C8.17232 14.3137 7.90663 14.0326 7.90663 13.6858V10.1785L7.3372 10.781C7.10546 11.0262 6.72976 11.0262 6.49802 10.781C6.26628 10.5358 6.26628 10.1382 6.49802 9.89303L8.08046 8.21861C8.31221 7.97339 8.68787 7.97339 8.91962 8.21861L10.502 9.89303C10.7338 10.1382 10.7338 10.5358 10.502 10.781Z"
          fill={color}
        />
      </g>
    </SvgIcon>
  );
}
